/*
 *               _
 *              | |
 *           ___| |_ ___  _ __
 *          / __| __/ _ \| '_ \
 *          \__ \ || (_) | |_) |
 *          |___/\__\___/| .__/
 *                       | |
 *                       |_|
 *
 * Please do not add to this file.
 * Additions to this file will get pulled into the main JS bundle where they probably don't need to be
 * Please create a new file, add your methods/constants to that and import just the code you need.
 *
 * For more info see https://github.com/Junglescout/docs/blob/master/client/Code-Splitting.md
 */

// Global UI state action constants
export const PENDING_GLOBAL_ACTION = 'PENDING_GLOBAL_ACTION'
export const COMPLETED_GLOBAL_ACTION = 'COMPLETED_GLOBAL_ACTION'
export const RESET_GLOBAL_ACTION = 'RESET_GLOBAL_ACTION'

export const COMPLETED_ADD_LOCATION_HISTORY = 'COMPLETED_ADD_LOCATION_HISTORY'
export const LOAD_GLOBAL_DATA = 'LOAD_GLOBAL_DATA'
export const SET_GLOBAL_DATA = 'SET_GLOBAL_DATA'
export const SET_GLOBAL_MODAL = 'SET_GLOBAL_MODAL'
export const SET_GLOBAL_MODAL_METADATA = 'SET_GLOBAL_MODAL_METADATA'

export const SET_NOTIFICATION = 'SET_NOTIFICATION'

export const SET_SUBSCRIPTION_INFO = 'SET_SUBSCRIPTION_INFO'

export const UPDATE_FEATURE_ACCESS = 'UPDATE_FEATURE_ACCESS'

export const TOGGLE_JSPUP_WARNING = 'TOGGLE_JSPUP_WARNING'

export const SET_SELLER_PLANS = 'SET_SELLER_PLANS'

export const TOGGLE_PROFIT_CALCULATOR = 'TOGGLE_PROFIT_CALCULATOR'

// Chrome Extension Constants
export const PENDING_EXTENSION_ACTION = 'PENDING_EXTENSION_ACTION'
export const COMPLETED_EXTENSION_ACTION = 'COMPLETED_EXTENSION_ACTION'
export const RESET_EXTENSION_ACTION = 'RESET_EXTENSION_ACTION'

// For Address fields
export const ADDRESS_INPUT_FIELD_UPDATE = 'ADDRESS_INPUT_FIELD_UPDATE'
export const ADD_ADDRESS_FORM_VALIDATION_ERROR =
  'ADD_ADDRESS_FORM_VALIDATION_ERROR'

// Registrations Constants
export const REGISTRATION_INPUT_FIELD_UPDATE = 'REGISTRATION_INPUT_FIELD_UPDATE'
export const ADD_REGISTRATION_FORM_VALIDATION_ERROR =
  'ADD_REGISTRATION_FORM_VALIDATION_ERROR'

export const PENDING_REGISTRATION_ACTION = 'PENDING_REGISTRATION_ACTION'
export const COMPLETED_REGISTRATION_ACTION = 'COMPLETED_REGISTRATION_ACTION'
export const RESET_REGISTRATION_ACTION = 'RESET_REGISTRATION_ACTION'

export const SET_REGISTRATION_INFO = 'SET_REGISTRATION_INFO'
export const SET_REGISTRATION_UPSELL_INFO = 'SET_REGISTRATION_UPSELL_INFO'
export const CLEAR_REGISTRATION_INFO = 'CLEAR_REGISTRATION_INFO'
export const SET_REGISTRATION_EMAIL_STATUS = 'SET_REGISTRATION_EMAIL_STATUS'

export const LOAD_UPSELL_CONFIRMATION = 'LOAD_UPSELL_CONFIRMATION'
export const LOAD_UPSELL_TABLE = 'LOAD_UPSELL_TABLE'
export const SELECT_UPGRADE_OPTION = 'SELECT_UPGRADE_OPTION'
export const TOGGLE_UPSELL_CONFIRMATION = 'TOGGLE_UPSELL_CONFIRMATION'
export const UPDATE_ELIGIBLE = 'UPDATE_ELIGIBLE'
export const PENDING_EXISTING_USER_CHECKOUT_ACTION =
  'PENDING_EXISTING_USER_CHECKOUT_ACTION'
export const RESET_EXISTING_USER_CHECKOUT_ACTION =
  'RESET_EXISTING_USER_CHECKOUT_ACTION'
export const PENDING_EXISTING_USER_CHECKOUT_ACTION_WITH_NEW_PAYMENT =
  'PENDING_EXISTING_USER_CHECKOUT_ACTION_WITH_NEW_PAYMENT'
export const SET_RETRY_ALIPAY = 'SET_RETRY_ALIPAY'

// Sessions Constants
export const SESSION_INPUT_FIELD_UPDATE = 'SESSION_INPUT_FIELD_UPDATE'
export const ADD_SESSION_VALIDATION_ERROR = 'ADD_SESSION_VALIDATION_ERROR'
export const PENDING_SESSION_ACTION = 'PENDING_SESSION_ACTION'
export const COMPLETED_SESSION_ACTION = 'COMPLETED_SESSION_ACTION'
export const RESET_SESSION_ACTION = 'RESET_SESSION_ACTION'
export const TOGGLE_AUTHY_MODAL = 'TOGGLE_AUTHY_MODAL'
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL'
export const LOADED_FEATURE_FLAGS = 'LOADED_FEATURE_FLAGS'

// ADMIN

// Base Plans
export const REPLACE_ADMIN_BASE_PLANS = 'REPLACE_ADMIN_BASE_PLANS'
export const PENDING_ADMIN_BASE_PLANS_ACTION = 'PENDING_ADMIN_BASE_PLANS_ACTION'
export const UPDATE_ADMIN_BASE_PLANS_PAGINATION =
  'UPDATE_ADMIN_BASE_PLANS_PAGINATION'
export const COMPLETED_ADMIN_BASE_PLANS_ACTION =
  'COMPLETED_ADMIN_BASE_PLANS_ACTION'
export const TOGGLE_ADMIN_BASE_PLANS_DELETE_MODAL =
  'TOGGLE_ADMIN_BASE_PLANS_DELETE_MODAL'
export const SORT_ADMIN_BASE_PLANS_TABLE = 'SORT_ADMIN_BASE_PLANS_TABLE'
export const UPDATE_ADMIN_BASE_PLANS_SELECTION =
  'UPDATE_ADMIN_BASE_PLANS_SELECTION'
export const TOGGLE_ADMIN_BASE_PLANS_FILTER_DROPDOWN =
  'TOGGLE_ADMIN_BASE_PLANS_FILTER_DROPDOWN'
export const UPDATE_ADMIN_BASE_PLANS_STATUS_FILTER =
  'UPDATE_ADMIN_BASE_PLANS_STATUS_FILTER'
export const COMPLETED_BASE_PLAN_SHOW = 'COMPLETED_BASE_PLAN_SHOW'
export const TOGGLE_ADMIN_BASE_PLANS_MODAL = 'TOGGLE_ADMIN_BASE_PLANS_MODAL'
export const CLOSE_ADMIN_BASE_PLAN_MODALS = 'CLOSE_ADMIN_BASE_PLAN_MODALS'
export const SET_CREATE_BASE_PLAN_STEP = 'SET_CREATE_BASE_PLAN_STEP'
export const SET_EDIT_BASE_PLAN_TAB = 'SET_EDIT_BASE_PLAN_TAB'
export const REQUEST_UPDATE_BASE_PLAN = 'REQUEST_UPDATE_BASE_PLAN'
export const RECEIVE_UPDATE_BASE_PLAN = 'RECEIVE_UPDATE_BASE_PLAN'
export const REQUEST_CREATE_BASE_PLAN = 'REQUEST_CREATE_BASE_PLAN'
export const RECEIVE_CREATE_BASE_PLAN = 'RECEIVE_CREATE_BASE_PLAN'
export const SET_BASE_PLAN_IS_CREATE_STEP_VALID =
  'SET_BASE_PLAN_IS_CREATE_STEP_VALID'
export const UPDATE_ADMIN_BASE_PLAN_FILTER = 'UPDATE_ADMIN_BASE_PLAN_FILTER'

// Campaigns
export const PENDING_ADMIN_CAMPAIGNS_ACTION = 'PENDING_ADMIN_CAMPAIGNS_ACTION'
export const COMPLETED_ADMIN_CAMPAIGNS_ACTION =
  'COMPLETED_ADMIN_CAMPAIGNS_ACTION'
export const COMPLETED_ADMIN_CAMPAIGNS_AND_BASE_PLANS_LOAD =
  'COMPLETED_ADMIN_CAMPAIGNS_AND_BASE_PLANS_LOAD'
export const REPLACE_ADMIN_CAMPAIGNS = 'REPLACE_ADMIN_CAMPAIGNS'
export const SORT_ADMIN_CAMPAIGNS_TABLE = 'SORT_ADMIN_CAMPAIGNS_TABLE'
export const UPDATE_ADMIN_CAMPAIGNS_SELECTION =
  'UPDATE_ADMIN_CAMPAIGNS_SELECTION'
export const UPDATE_ADMIN_CAMPAIGNS_FILTER = 'UPDATE_ADMIN_CAMPAIGNS_FILTER'

export const TOGGLE_ADMIN_CAMPAIGNS_FILTER_DROPDOWN =
  'TOGGLE_ADMIN_CAMPAIGNS_FILTER_DROPDOWN'
export const UPDATE_ADMIN_CAMPAIGNS_PAGINATION =
  'UPDATE_ADMIN_CAMPAIGNS_PAGINATION'
export const COMPLETED_CAMPAIGN_SHOW = 'COMPLETED_CAMPAIGN_SHOW'
export const TOGGLE_ADMIN_CAMPAIGNS_MODAL = 'TOGGLE_ADMIN_CAMPAIGNS_MODAL'
export const TOGGLE_CAMPAIGNS_EXPIRATION_REASON =
  'TOGGLE_CAMPAIGNS_EXPIRATION_REASON'
export const SET_CREATE_CAMPAIGN_STEP = 'SET_CREATE_CAMPAIGN_STEP'
export const SET_EDIT_CAMPAIGN_TAB = 'SET_EDIT_CAMPAIGN_TAB'
export const REQUEST_CREATE_CAMPAIGN = 'REQUEST_CREATE_CAMPAIGN'
export const RECEIVE_CREATE_CAMPAIGN = 'RECEIVE_CREATE_CAMPAIGN'
export const REQUEST_UPDATE_CAMPAIGN = 'REQUEST_UPDATE_CAMPAIGN'
export const RECEIVE_UPDATE_CAMPAIGN = 'RECEIVE_UPDATE_CAMPAIGN'
export const REQUEST_CAMPAIGN_BASE_PLAN_OPTIONS =
  'REQUEST_CAMPAIGN_BASE_PLAN_OPTIONS'
export const RECEIVE_CAMPAIGN_BASE_PLAN_OPTIONS =
  'RECEIVE_CAMPAIGN_BASE_PLAN_OPTIONS'
export const TOGGLE_ADMIN_CAMPAIGNS_DELETE_MODAL =
  'TOGGLE_ADMIN_CAMPAIGNS_DELETE_MODAL'
export const SET_CAMPAIGN_IS_CREATE_STEP_VALID =
  'SET_CAMPAIGN_IS_CREATE_STEP_VALID'

// Admin Users
export const PENDING_ADMIN_USER_ACTION = 'PENDING_ADMIN_USER_ACTION'
export const COMPLETED_ADMIN_USER_ACTION = 'COMPLETED_ADMIN_USER_ACTION'
export const RESET_ADMIN_USER_ACTION = 'RESET_ADMIN_USER_ACTION'

export const PENDING_ADMIN_JS_USERS_ACTION = 'PENDING_ADMIN_JS_USERS_ACTION'
export const COMPLETED_ADMIN_JS_USERS_ACTION = 'COMPLETED_ADMIN_JS_USERS_ACTION'
export const RESET_ADMIN_JS_USERS_ACTION = 'RESET_ADMIN_JS_USERS_ACTION'

export const COMPLETED_ADMIN_SEARCH_USERS = 'COMPLETED_ADMIN_SEARCH_USERS'
export const TOGGLE_EDIT_ADMIN_USER_EXTENSION =
  'TOGGLE_EDIT_ADMIN_USER_EXTENSION'
export const TOGGLE_EDIT_ADMIN_USER_MEMBERSHIP =
  'TOGGLE_EDIT_ADMIN_USER_MEMBERSHIP'

export const COMPLETED_ADMIN_USERS_TABLE_HEADER_SORT =
  'COMPLETED_ADMIN_USERS_TABLE_HEADER_SORT'
export const SET_ADMIN_USER_FILTER = 'SET_ADMIN_USER_FILTER'
export const SET_ADMIN_USER_PAGE = 'SET_ADMIN_USER_PAGE'
export const RESET_ADMIN_USER_FILTERS = 'RESET_ADMIN_USER_FILTERS'
export const COMPLETED_ADMIN_SHOW_USER = 'COMPLETED_ADMIN_SHOW_USER'
export const RESET_ADMIN_SELECTED_USER = 'RESET_ADMIN_SELECTED_USER'
export const RESET_ADMIN_SELECTED_USER_PRODUCT_INSTANCE_DATA =
  'RESET_ADMIN_SELECTED_USER_PRODUCT_INSTANCE_DATA'
export const UPDATE_ADMIN_SELECTED_USER = 'UPDATE_ADMIN_SELECTED_USER'
export const ADMIN_USER_INPUT_FIELD_UPDATE = 'ADMIN_USER_INPUT_FIELD_UPDATE'
export const COMPLETED_CREATE_USER_ADMIN_NOTE =
  'COMPLETED_CREATE_USER_ADMIN_NOTE'
export const UPDATE_USER_ADMIN_NOTE = 'UPDATE_USER_ADMIN_NOTE'

export const COMPLETED_ADMIN_USER_TEXT_AREA_CHANGE =
  'COMPLETED_ADMIN_USER_TEXT_AREA_CHANGE'
export const COMPLETED_SELECT_CHARGE_TO_REFUND =
  'COMPLETED_SELECT_CHARGE_TO_REFUND'
export const COMPLETED_SELECT_BALANCE_TRANSACTION =
  'COMPLETED_SELECT_BALANCE_TRANSACTION'
export const COMPLETED_CLOSE_CHARGES_MODAL = 'COMPLETED_CLOSE_CHARGES_MODAL'
export const COMPLETED_CLOSE_BALANCE_TRANSACTION_MODAL =
  'COMPLETED_CLOSE_BALANCE_TRANSACTION_MODAL'
export const COMPLETED_REFUND_INPUT_CHANGE = 'COMPLETED_REFUND_INPUT_CHANGE'
export const COMPLETED_BALANCE_TRANSACTION_INPUT_CHANGE =
  'COMPLETED_BALANCE_TRANSACTION_INPUT_CHANGE'
export const COMPLETED_SHOW_SUBSCRIPTION_RAW_DATA_MODAL =
  'COMPLETED_SHOW_SUBSCRIPTION_RAW_DATA_MODAL'
export const COMPLETED_CLOSE_SUBSCRIPTION_RAW_DATA_MODAL =
  'COMPLETED_CLOSE_SUBSCRIPTION_RAW_DATA_MODAL'
export const ADMIN_ACCESS_RIGHTS_INPUT_FIELD_UPDATE =
  'ADMIN_ACCESS_RIGHTS_INPUT_FIELD_UPDATE'
export const ADMIN_ADDITIONAL_USER_INPUT_FIELD_UPDATE =
  'ADMIN_ADDITIONAL_USER_INPUT_FIELD_UPDATE'
export const TOGGLE_ADMIN_USER_CONFIRMATION_MODAL =
  'TOGGLE_ADMIN_USER_CONFIRMATION_MODAL'
export const SET_ADMIN_USER_VENDOR_CENTRAL_EMAIL_INPUT =
  'SET_ADMIN_USER_VENDOR_CENTRAL_EMAIL_INPUT'

// // Dashboard
export const PENDING_ADMIN_DASHBOARD_ACTION = 'PENDING_ADMIN_DASHBOARD_ACTION'
export const COMPLETED_ADMIN_DASHBOARD_ACTION =
  'COMPLETED_ADMIN_DASHBOARD_ACTION'
export const RESET_ADMIN_DASHBOARD_ACTION = 'COMPLETED_ADMIN_DASHBOARD_ACTION'
export const COMPLETED_ADMIN_DASHBOARD_TOTALS_LOAD =
  'COMPLETED_ADMIN_DASHBOARD_TOTALS_LOAD'

// //Products
export const PENDING_ADMIN_PRODUCTS_ACTION = 'PENDING_ADMIN_PRODUCTS_ACTION'
export const COMPLETED_ADMIN_PRODUCTS_ACTION = 'COMPLETED_ADMIN_PRODUCTS_ACTION'
export const RESET_ADMIN_PRODUCTS_ACTION = 'RESET_ADMIN_PRODUCTS_ACTION'
export const COMPLETED_ADMIN_PRODUCTS_LOAD = 'COMPLETED_ADMIN_PRODUCTS_LOAD'
export const ADMIN_PRODUCTS_INPUT_FIELD_UPDATE =
  'ADMIN_PRODUCTS_INPUT_FIELD_UPDATE'
export const ADD_ADMIN_PRODUCTS_ERROR = 'ADD_ADMIN_PRODUCTS_ERROR'

// //Keywords
export const PENDING_ADMIN_KEYWORDS_ACTION = 'PENDING_ADMIN_KEYWORDS_ACTION'
export const COMPLETED_ADMIN_KEYWORDS_ACTION = 'COMPLETED_ADMIN_KEYWORDS_ACTION'
export const RESET_ADMIN_KEYWORDS_ACTION = 'RESET_ADMIN_KEYWORDS_ACTION'
export const COMPLETED_ADMIN_KEYWORDS_LOAD = 'COMPLETED_ADMIN_KEYWORDS_LOAD'
export const ADMIN_KEYWORDS_INPUT_FIELD_UPDATE =
  'ADMIN_KEYWORDS_INPUT_FIELD_UPDATE'
export const ADD_ADMIN_KEYWORDS_ERROR = 'ADD_ADMIN_KEYWORDS_ERROR'

// //Stripe Plans
export const COMPLETE_ADMIN_STRIPE_PLAN_LOAD = 'COMPLETE_ADMIN_STRIPE_PLAN_LOAD'

export * from './action_types/global'

// Admin
export * from './action_types/admin/users'
export * from './action_types/admin/stripe_coupons'

// Settings
export * from './action_types/settings/email_settings'

// Seats
export * from './action_types/seats'

export * from './action_types/chatbot'

// Segments
export const UPDATE_SEGMENT_SUBSCRIPTION = 'UPDATE_SEGMENT_SUBSCRIPTION'
